<template>
  <Modal
    confirmText="Kom igång"
    @cancel="$emit('close')"
    @confirm="$emit('close')"
    :addSpace=false
  >
    <div class="flex flex-col items-center text-center">
      <div class="w-full">

        <div class="flex justify-center"><IconNewUser class="min-w-[64px] mb-2" /></div>


        <h3 class="text-t6 text-left mt-4 mb-2">Välkommen till Gavlegårdarna</h3>
        <p class="text-b2 text-left">Du är registrerad och kommer för varje dag att samla en köpoäng. Du kan redan nu börja leta efter en bostad som passar dig!</p>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/modal';
import IconNewUser from '@/components/icons/IconNewUser';

export default {
  name: 'NewUser',
  components: {
    Modal,
    IconNewUser
  },
};
</script>
